import { api } from "./api";
import type { Attachment } from "@/types/models";

export const attachmentService = {
  upload: (file: File): Promise<Attachment> => {
    const formData = new FormData();
    formData.append("file", file);
    return api
      .post<Attachment>("/attachments/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  listBySource: (
    sourceType: string,
    sourceId: number
  ): Promise<Attachment[]> =>
    api
      .get<Attachment[]>("/attachments", {
        params: { source_type: sourceType, source_id: sourceId },
      })
      .then((r) => r.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/attachments/${id}`).then(() => undefined),

  reorder: (
    sourceType: string,
    sourceId: number,
    attachmentIds: number[]
  ): Promise<void> =>
    api
      .put("/attachments/reorder", {
        source_type: sourceType,
        source_id: sourceId,
        attachment_ids: attachmentIds,
      })
      .then(() => undefined),
};
